import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Users } from "lucide-react";
import { api } from "@/lib/api";
import { PlatformAccess } from "@/components/PlatformAccess";

const NAMES = { olaparty: "Qwick Live", trumeet: "Trumeet" };

export const ResellerAccessCard = ({ reseller, onSaved }) => {
  const [subs, setSubs] = useState([]);
  useEffect(() => { api.get(`/admin/resellers/${reseller.id}/subagents`).then((r) => setSubs(r.data.subagents)).catch(() => {}); }, [reseller.id]);
  const save = async (list) => {
    if (!list.length) { toast.error("Keep at least one platform enabled"); return; }
    try { await api.patch(`/admin/resellers/${reseller.id}`, { allowed_platforms: list }); toast.success("Platforms updated"); onSaved(); }
    catch (e) { toast.error(e.response?.data?.detail || "Update failed"); }
  };
  return (
    <div className="bg-white border border-zinc-200 rounded-lg p-4 space-y-4" data-testid="reseller-access-card">
      <div>
        <div className="text-sm font-semibold text-zinc-900">Platforms this reseller can recharge</div>
        <p className="text-xs text-zinc-500 mb-2">Only these show for the reseller and their sub-agents.</p>
        <PlatformAccess value={reseller.allowed_platforms} onChange={save} testid="reseller-access-platforms" />
      </div>
      <div>
        <div className="text-sm font-semibold text-zinc-900 flex items-center gap-1.5"><Users className="w-4 h-4" /> Sub-agents ({subs.length})</div>
        <div className="mt-2 divide-y divide-zinc-100 text-xs" data-testid="reseller-subagents-list">
          {subs.map((s) => (
            <div key={s.id} className="py-2 flex flex-wrap justify-between gap-2">
              <span><strong>{s.name}</strong> · {s.email} · {s.active ? "Active" : "Blocked"}</span>
              <span className="font-mono">{s.allowed_platforms.map((k) => `${NAMES[k] || k}: ${(s.balances?.[k]?.balance ?? 0).toLocaleString()}`).join(" · ")}</span>
            </div>
          ))}
          {subs.length === 0 && <div className="py-2 text-zinc-400">No sub-agents.</div>}
        </div>
      </div>
    </div>
  );
};
